import { useProduct as sharedUseProduct } from '@shared/products-core';

export const useProduct: typeof sharedUseProduct = (...args) => sharedUseProduct(...args);
